export const PERIOD_TYPES = {
    ADVERB: 'adverb',
    NOUN: 'noun',
};
